/**
 * Krisp + MediaPipe no mesmo cliente saturam CPU e, ao desligar o filtro
 * no meio da call, o pipeline de áudio pode ficar mudo.
 */

export type KrispBackgroundDecision =
  | { action: 'none' }
  | { action: 'pause'; toast: boolean }
  | { action: 'resume' };

export function decideKrispForBackground(input: {
  isVirtualBackgroundActive: boolean;
  isNoiseFilterEnabled: boolean;
  isPending: boolean;
  isSupported: boolean;
  pausedForBackground: boolean;
}): KrispBackgroundDecision {
  if (!input.isSupported || input.isPending) {
    return { action: 'none' };
  }

  if (input.isVirtualBackgroundActive && input.isNoiseFilterEnabled) {
    return { action: 'pause', toast: !input.pausedForBackground };
  }

  if (!input.isVirtualBackgroundActive && input.pausedForBackground) {
    return { action: 'resume' };
  }

  return { action: 'none' };
}

export async function applyKrispBackgroundDecision(
  decision: KrispBackgroundDecision,
  setNoiseFilterEnabled: (enabled: boolean) => void | Promise<void>,
): Promise<{ ok: boolean; error?: string }> {
  if (decision.action === 'none') {
    return { ok: true };
  }

  try {
    await setNoiseFilterEnabled(decision.action === 'resume');
    return { ok: true };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    return { ok: false, error: message };
  }
}

export async function recoverLocalMicrophone(
  setMicrophoneEnabled: (enabled: boolean) => Promise<unknown>,
): Promise<boolean> {
  try {
    await setMicrophoneEnabled(true);
    return true;
  } catch {
    return false;
  }
}
